export default __webpack_public_path__ + "static/media/organiser-logo.142241df.jpg";